import script from "./afterSales.vue?vue&type=script&setup=true&lang=js"
export * from "./afterSales.vue?vue&type=script&setup=true&lang=js"

import "./afterSales.vue?vue&type=style&index=0&id=3ec8fc77&scoped=true&lang=css"
import "./afterSales.vue?vue&type=style&index=1&id=3ec8fc77&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ec8fc77"]])

export default __exports__